import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-airtimeCarrier-lookup',
  templateUrl: './micro-airtimeCarrier-lookup.component.html'
})
export class MicroAirtimeCarrierLookupComponent  {

  @Input()
  airtimeCarrierId:any;

  @Input()
  link:boolean = true;
}
